export function getInsureViewId(insureOfferId: string | number): number {
    return 100 + +insureOfferId;
}
